<div class="wrapper fadeInDown">
  <div id="formContent">
    <!-- Tabs Titles -->

    <!-- Icon -->
    <div class="fadeIn first">
      <img src="assets/logo-DANE.png" id="icon" alt="User Icon" />
    </div>
    <br>

    <!-- Bienvenido -->
    <div class="row">
      <div class="col-4">
        <br>
        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onLogin(loginForm.value)">
          <input type="text" id="login" class="fadeIn second"  placeholder="Usuario" formControlName="username" required>
          <input type="password" id="password" class="fadeIn third"  placeholder="Contraseña" formControlName="password">
          <a (click)="recuperarContrasena()" type="link"><u>¿Olvidó su contraseña?</u></a>
          <div id="re-captcha">
            <!--re-captcha  (resolved)="resolved($event)" siteKey="6LcaSzUeAAAAACfXNKJ1EPjy-4nFZTOmsmVb1n3L" ></re-captcha-->
            <div class="cf-turnstile" data-sitekey="0x4AAAAAAB7DDyzI5tIjrPZO"></div>
          </div>
          <input type="submit" class="fadeIn fourth" value="Ingresar" *ngIf="btnIngresar">
          <div class="d-flex justify-content-center" *ngIf="!btnIngresar">
            <div class="spinner-border text-danger" role="status" style="width: 60px; height: 60px;">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
        <!-- Show error -->
        <div class="alert alert-danger" *ngIf="errorStatus">
          <p>{{errorMsj}}</p>
        </div>
      </div>
      <div class="col-8">
        <p style="text-align: center; margin-right: 40px;">
          <b>Bienvenido al sistema de captura de información de Cartera Hipotecaria de Vivienda - CHV y Financiación de Vivienda - FIVI</b>
        </p>
        <p style="text-align: justify; margin-right: 40px;" >
          El Departamento Administrativo Nacional de Estadística DANE, con el propósito de agilizar y facilitar el reporte correcto y oportuno de los datos
          estadísticos requeridos por CARTERA HIPOTECARIA DE VIVIENDA y/o FINANCIACIÓN DE VIVIENDA, pone a su disposición el presente sistema de captura,
          con el cual podrá diligenciar y verificar en línea la consistencia de su información.
        </p>
        <p style="text-align: justify; margin-right: 40px;" >
          Normatividad: dando cumplimiento a lo dispuesto en la Ley 1581 de 2012, "Por la cual se dicta disposiciones generales para la protección de datos
          personales." y de conformidad con lo señalado en el Decreto 1377 de 2013, al diligenciar la información solicitada por la/s operación/es estadística/s,
          autorizo al DANE para que de manera conjunta o separadamente recolecte, use y trate mis datos personales conforme la "política de Tratamientos de Datos
          Personales" del DANE disponible en la página Web de la entidad y de acuerdo con lo previsto en la Ley 79 de 1993 o la norma que la adicione, modifique o
          sustituya, se deberá remitir el Departamento Administrativo Nacional de Estadística - DANE, la información solicitada.
        </p>
        <p style="text-align: justify; margin-right: 40px;">
          Gracias por su colaboración, si tiene alguna inquietud, comuníquese al número de teléfono (057) 5978300 extensión 3219 o al correo <u>chv-fivi@dane.gov.co</u>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Ventana recuperar contraseña-->
<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalRecuperar" style="visibility: hidden;" #openModalRecuContraseña>Launch static backdrop modal</button>

<!-- Modal -->
<div class="modal fade" id="modalRecuperar" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalRecuperarLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modalRecuperarLabel" style="color: white;">Restablecer Contraseña</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row justify-content-center">
            <div class="col-auto"><label>Para restablecer su clave por favor ingrese nombre de usuario y la clave será enviada al correo registrado en el sistema.</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-4"><label>Ingrese usuario :</label></div>
            <div class="col-6"><input type="text" class="form-control" id="contrasenaactual" name="contrasenaactual" [formControl]="RecuFormControl"></div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closeModalRecuContraseña style="visibility: hidden;">Close</button>
        <button type="button" class="btn btn-primary" [disabled]="RecuFormControl.invalid" style="background-color: #be0c4d;" (click)="enviarCorreo()">Enviar</button>
      </div>
    </div>
  </div>
</div>